import React from 'react';
// import logo from './logo.svg';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
import ComingSoon from './page/ComingSoon';


function App() {
  return (
    <div className="App">
      <ComingSoon />
    </div>
  );
}

export default App;
